module.exports = __webpack_public_path__ + "img/ic-search.7458d1ba.svg";